<div class="container">
    <div class="text-center">
  
      <b>กรุณากรอกรหัสพนักงาน</b>
      <br>
    </div>
  </div>
  <div class="content">
      <div class="content-header">
  
      </div>
      <div class="content-body">
        <div class="m-2">
          <input id="Messages" class="body-input" type="text" [(ngModel)]="messages" #Messages="ngModel" [class.border-danger]="isSubmit && Messages.invalid" (keyup)="onCheckEnter($event)" required>
        </div>
        <div class="m-2">
          <button class="body-btn" (click)="onSubmit()">ยืนยัน</button>
        </div>
      </div>
      <div class="content-footer">
  
      </div>
</div>